import { z } from 'zod'

export const signupSchema = z.object({
  email: z.string().email({ message: "Invalid email address" }).min(1, { message: "Email is required" }),
  code: z.string().optional(),
  firstName:z.string().optional(),
  lastName:z.string().optional(),
  password: z.string().optional(),
  confirmPassword: z.string().optional()
})

export const loginSchemaMembers = z.object({
  name: z.string().min(5, { message: "Not less than 5 characters" }).refine(
    (val) => /^[a-z]/.test(val),
    {
      message: "Username must start with a lowercase letter",
    }
  ).refine((val) => !/\s/.test(val), {
    message: "Username cannot contain spaces",
  }),
  password: z.string().min(6, { message: "Password must be at least 6 characters" })
})

export const loginSchema = z.object({
  email: z.string().email({ message: "Email is required" }).min(5, { message: "Not less than 5 characters" }),
  password: z.string().min(6, { message: "Password must be at least 6 characters" })
})

export type LoginFormValuesMembers = z.infer<typeof loginSchemaMembers>
export type LoginFormValues = z.infer<typeof loginSchema>
export type SignupFormValues = z.infer<typeof signupSchema>
